(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[40545],{

/***/ 78879:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands/[...blog]",
      function () {
        return __webpack_require__(52877);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ SeveralBrandsHome; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/layouts/severalBrandsWrapper.tsx + 9 modules
var severalBrandsWrapper = __webpack_require__(73191);
// EXTERNAL MODULE: ./src/components/severalbrands/blog/firstSection/style.module.scss
var style_module = __webpack_require__(72875);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./src/components/severalbrands/blog/firstSection/icons/facebook.tsx


function FaceBookIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 42 42",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "21",
                cy: "21",
                r: "21",
                fill: "#4B68AC"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M18.058 29h3.913v-8.578h2.732l.297-2.87h-3.029v-1.631c0-.684.149-.943.9-.943H25V12h-2.724c-2.919 0-4.233 1.12-4.233 3.265v2.295H16v2.902h2.043L18.058 29z"
            })
        ]
    });
}
/* harmony default export */ var facebook = (FaceBookIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/blog/firstSection/icons/x.tsx


function XIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 42 42",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "21",
                cy: "21",
                r: "21",
                fill: "#000"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_5_49273)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    fill: "#fff",
                    d: "M22.522 19.195L28.48 12h-1.412l-5.172 6.247L17.765 12H13l6.247 9.447L13 28.99h1.412l5.461-6.597 4.363 6.597H29l-6.478-9.796zM20.59 21.53l-.633-.94-5.036-7.486h2.168l4.064 6.04.633.941 5.283 7.852H24.9l-4.311-6.407z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_5_49273",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H16V17H0z",
                        transform: "translate(13 12)"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var x = (XIcon);

;// CONCATENATED MODULE: ./src/components/severalbrands/blog/firstSection/icons/copyLinkIcon.tsx


function CopyLinkIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 48 48",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "24",
                cy: "24",
                r: "24",
                fill: "#351C4F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M30.79 17.217A4.115 4.115 0 0027.853 16c-1.11 0-2.147.43-2.934 1.217l-1.915 1.897a.919.919 0 000 1.324.919.919 0 001.324 0l1.897-1.897c.859-.859 2.362-.859 3.203 0a2.279 2.279 0 010 3.203l-3.131 3.186c-.86.858-2.363.858-3.204 0a.919.919 0 00-1.324 0 .919.919 0 000 1.324 4.114 4.114 0 002.935 1.216c1.11 0 2.147-.429 2.935-1.216l3.167-3.168a4.115 4.115 0 001.217-2.934c0-1.11-.448-2.148-1.235-2.935z"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#fff",
                d: "M22.663 28.544l-1.896 1.915a2.279 2.279 0 01-3.204 0 2.279 2.279 0 010-3.203l3.168-3.168a2.279 2.279 0 013.203 0 .919.919 0 001.324 0 .919.919 0 000-1.324c-1.628-1.628-4.259-1.628-5.87 0l-3.167 3.15c-1.628 1.628-1.628 4.259 0 5.87A4.163 4.163 0 0019.156 33c1.056 0 2.13-.411 2.935-1.217l1.897-1.897a.919.919 0 000-1.324.934.934 0 00-1.325-.018z"
            })
        ]
    });
}
/* harmony default export */ var copyLinkIcon = (CopyLinkIcon);

// EXTERNAL MODULE: ./src/components/severalbrands/utils/index.ts
var utils = __webpack_require__(54531);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 111 modules
var motion = __webpack_require__(76265);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
;// CONCATENATED MODULE: ./src/components/severalbrands/blog/firstSection/index.tsx









function FirstSection({ post , mainUrl  }) {
    const category = post?.category?.label ?? post?.category?.name;
    const { 0: showCopySuccessMessage , 1: setShowCopySuccessMessage  } = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (style_module_default()).bgStyle,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "lg:pb-20 pb-10 lg:pt-36 pt-10 px-4 lg:px-0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between flex-col lg:flex-row",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "3xl:max-w-[900px] lg:max-w-[600px] ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "font-bold 3xl:text-7xl 3xl:leading-[5.5rem] lg:text-5xl lg:leading-[4.5rem] text-2xl leading-9 ",
                                children: (0,sharedUtils/* replacePlaceholders */.wT)(post.title, {
                                    category
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "3xl:text-xl lg:text-base text-sm text-[#818181] mt-1 lg:mt-0 3xl:mt-1 mb-3 lg:mb-0",
                                children: [
                                    "Last Updated On : ",
                                    (0,utils/* getFormattedDate */.L0)(post.updatedAt)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "3xl:text-3xl lg:text-2xl text-lg mb-3",
                                children: "Share this post"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex gap-2 mt-2 lg:mt-0 lg:justify-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.span */.E.span, {
                                        onClick: ()=>{
                                            window.open(`https://www.facebook.com/sharer/sharer.php?u=${(0,utils/* getUrl */.Gr)(mainUrl)}`, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");
                                            return false;
                                        },
                                        style: {
                                            borderRadius: "50% 50%"
                                        },
                                        className: "cursor-pointer relative 3xl:w-[52px] 3xl:h-[52px] sm:w-[42px] sm:h-[42px] w-[32px] h-[32px]",
                                        whileHover: {
                                            y: [
                                                0,
                                                -9
                                            ]
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(facebook, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.span */.E.span, {
                                        onClick: ()=>{
                                            window.open(`https://twitter.com/share?url=${(0,utils/* getUrl */.Gr)(mainUrl)}`, "", "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600");
                                            return false;
                                        },
                                        style: {
                                            borderRadius: "50% 50%"
                                        },
                                        className: "cursor-pointer relative 3xl:w-[52px] 3xl:h-[52px] sm:w-[42px] sm:h-[42px] w-[32px] h-[32px]",
                                        whileHover: {
                                            y: [
                                                0,
                                                -9
                                            ]
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(x, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.span */.E.span, {
                                        onClick: async ()=>{
                                            try {
                                                await navigator.clipboard.writeText(window.location.href);
                                                setShowCopySuccessMessage(true);
                                                setTimeout(()=>{
                                                    setShowCopySuccessMessage(false);
                                                }, 1000);
                                            } catch  {
                                                return;
                                            }
                                        },
                                        style: {
                                            borderRadius: "50% 50%"
                                        },
                                        className: "cursor-pointer relative 3xl:w-[52px] 3xl:h-[52px] sm:w-[42px] sm:h-[42px] w-[32px] h-[32px]",
                                        whileHover: {
                                            y: [
                                                0,
                                                -9
                                            ]
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(copyLinkIcon, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: `${(style_module_default()).toolTipText} ${showCopySuccessMessage ? "inline-block" : "hidden"}`,
                                                children: "Copied to Clipboard"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./src/components/severalbrands/blog/secondSection/sideWidget/style.module.scss
var sideWidget_style_module = __webpack_require__(92665);
var sideWidget_style_module_default = /*#__PURE__*/__webpack_require__.n(sideWidget_style_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/components/severalbrands/tooltip/styles.module.scss
var styles_module = __webpack_require__(54365);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/severalbrands/tooltip/index.tsx



function Tooltip({ tooltipMessage , children , className  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).tooltip,
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: `${(styles_module_default()).toolTipText} ${className}`,
                children: tooltipMessage
            })
        ]
    });
}
/* harmony default export */ var tooltip = (Tooltip);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/severalbrands/blog/secondSection/sideWidget/closeIcon.tsx
var closeIcon = __webpack_require__(73536);
;// CONCATENATED MODULE: ./src/components/severalbrands/blog/secondSection/sideWidget/UpArrow.tsx


function UpArrow() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "100%",
        height: "100%",
        fill: "none",
        viewBox: "0 0 16 8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#58616D",
            fillRule: "evenodd",
            d: "M15.323 6.607L13.736 8 7.797 2.786 1.857 8 .272 6.607 7.797 0l7.526 6.607z",
            clipRule: "evenodd"
        })
    });
}
/* harmony default export */ var sideWidget_UpArrow = (UpArrow);

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 5 modules
var AnimatePresence = __webpack_require__(51526);
;// CONCATENATED MODULE: ./src/components/severalbrands/blog/secondSection/sideWidget/index.tsx










function SideWidget({ titlesList , allPosts  }) {
    const { 0: contentOpen , 1: setContentOpen  } = (0,react.useState)(true);
    const { 0: modalVisibility , 1: setModalVisibility  } = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "3xl:w-[586px] lg:w-[386px] relative h-[800px] lg:h-fit lg:sticky lg:top-28 ",
        children: [
            titlesList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `${(sideWidget_style_module_default()).contentsContainer} mb-8 hidden lg:block  ${contentOpen ? "pt-12 pb-16" : "py-4 3xl:py-6"} px-9 3xl:px-12 `,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: " flex justify-between items-center ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: `3xl:text-3xl  lg:text-xl text-lg font-semibold`,
                                children: "Content"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.span */.E.span, {
                                animate: {
                                    rotate: contentOpen ? 0 : 180
                                },
                                className: "block cursor-pointer relative w-[40px] h-[20px] p-1 3xl:w-[44px] 3xl:h-[22px]",
                                onClick: ()=>{
                                    setContentOpen((prev)=>!prev);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sideWidget_UpArrow, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                        children: contentOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                            initial: {
                                height: 0
                            },
                            animate: {
                                height: "auto"
                            },
                            exit: {
                                height: 0
                            },
                            className: `${(sideWidget_style_module_default()).linksList}  `,
                            children: titlesList?.map((title, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: `${(sideWidget_style_module_default()).bulletedListItem}`,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: title?.link ?? "#",
                                        dangerouslySetInnerHTML: {
                                            __html: title?.title
                                        },
                                        className: `   block  cursor-pointer 3xl:text-2xl 3xl:leading-10 lg:text-lg text-base hover:underline `
                                    })
                                }, index))
                        })
                    })
                ]
            }),
            modalVisibility ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `${(sideWidget_style_module_default()).contentsContainerList} ${(sideWidget_style_module_default()).fixedStyle}  `,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: `lg:text-xl text-lg font-semibold  w-full text-center`,
                                children: "Content"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "block w-fit p-1 cursor-pointer",
                                onClick: ()=>{
                                    setModalVisibility(false);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(closeIcon/* default */.Z, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `${(sideWidget_style_module_default()).linksList}  `,
                        children: titlesList?.map((title, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${(sideWidget_style_module_default()).bulletedListItem}`,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: title?.link ?? "#",
                                    dangerouslySetInnerHTML: {
                                        __html: title?.title
                                    },
                                    className: `   block  cursor-pointer lg:text-lg text-base `
                                })
                            }, index))
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `lg:hidden font-semibold py-4 px-[131px] rounded-[10px] bg-[#351C4f] text-white  text-center text-xl  ${(sideWidget_style_module_default()).fixedStyle}   `,
                onClick: ()=>{
                    setModalVisibility(true);
                },
                children: "Content"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `lg:bg-[#f5f5f5] lg:px-[35px] lg:pt-[50px] lg:pb-[65px]  rounded-[10px] `,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: `3xl:text-3xl  lg:text-xl text-3xl font-semibold text-center lg:text-left`,
                        children: "Must Read"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: ` mt-6 `,
                        children: allPosts?.map((post, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: post.url.isMain ? post.url.url : post.url.main.url,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: `bg-[#f5f5f5] lg:bg-transparent lg:mt-8 mt-3 first-of-type:mt-0 flex gap-[14px] rounded-[10px] lg:rounded-none p-[18px] lg:p-0 ${(sideWidget_style_module_default()).mustReadLinks}`,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "relative w-[119px] lg:h-[75px] h-[84px] 3xl:w-[180px] 3xl:h-[110px] ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: post.image ? post.image.fullPath : "/severalbrands/assets/images/placeHolder.png",
                                                layout: "fill",
                                                objectFit: "contain",
                                                alt: (0,sharedUtils/* replacePlaceholders */.wT)(post.title, {
                                                    category: post.category.label ?? post.category.name
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip, {
                                                    tooltipMessage: (0,sharedUtils/* replacePlaceholders */.wT)(post.title, {
                                                        category: post.category.label ?? post.category.name
                                                    }),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                        className: `mt-1 3xl:text-2xl text-lg ${(sideWidget_style_module_default())["ellipsis-container"]}  `,
                                                        children: (0,sharedUtils/* replacePlaceholders */.wT)(post.title, {
                                                            category: post.category.label ?? post.category.name
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: `3xl:text-xl 3xl:mt-6 mt-3 block text-[#818181] ${(sideWidget_style_module_default()).readMoreLink}  `,
                                                    children: "Read More"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, index))
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/severalbrands/blog/secondSection/mainContent/styles.module.scss
var mainContent_styles_module = __webpack_require__(8859);
var mainContent_styles_module_default = /*#__PURE__*/__webpack_require__.n(mainContent_styles_module);
;// CONCATENATED MODULE: ./src/components/severalbrands/blog/secondSection/mainContent/index.tsx





function MainContent({ post  }) {
    const category = post?.category?.label ?? post?.category?.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "3xl:w-[1073px] lg:w-[723px]",
        children: [
            post.image ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `relative`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: post.image.fullPath,
                            alt: (0,sharedUtils/* replacePlaceholders */.wT)(post.title, {
                                category
                            }),
                            layout: "responsive",
                            objectFit: "contain",
                            width: 723,
                            height: 480
                        })
                    }),
                    post.image.caption && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-gray-500 text-sm bg-[#fffcf1] px-2 py-1",
                        children: post.image.caption
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `relative w-full h-[480px]`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/severalbrands/assets/images/placeHolder.png",
                    alt: (0,sharedUtils/* replacePlaceholders */.wT)(post.title, {
                        category
                    }),
                    layout: "fill",
                    objectFit: "contain"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (mainContent_styles_module_default()).postContainerSeveralBrandsDomain,
                children: [
                    post.excerpt && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " mt-3 ",
                        dangerouslySetInnerHTML: {
                            __html: (0,sharedUtils/* replacePlaceholders */.wT)(post.excerpt, {
                                category
                            })
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: (0,utils/* addStyleClassToTable */.yV)((0,utils/* addStyleClassToIframe */.nn)((0,sharedUtils/* replacePlaceholders */.wT)(post.body, {
                                category
                            })))
                        }
                    })
                ]
            }),
            post.tags.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:mt-28 mt-14 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "3xl:text-6xl 3xl:leading-[5.5rem] lg:text-4xl text-2xl lg:leading-[4.5rem] font-semibold",
                        children: "Tags"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-row flex-wrap gap-3 lg:mt-5 mt-3",
                        children: post.tags?.map((el)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `rounded-[10px] border border-[#81818130] 3xl:px-[25px] 3xl:py-[18px] py-[14px] px-[21px] 3xl:text-2xl lg:text-lg text-base`,
                                children: el.name
                            }, el.id))
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/components/severalbrands/blog/secondSection/index.tsx






function SecondSection({ post , allPosts  }) {
    const category = post?.category?.label ?? post?.category?.name;
    const finalPosts = allPosts.filter((blog)=>blog.id !== post.id).slice(0, 4);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "lg:mt-20 mt-5 lg:mb-48 mb-24 ",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: " flex flex-col lg:flex-row 3xl:gap-[140px] lg:gap-[100px] gap-[62px] ",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MainContent, {
                    post: post
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SideWidget, {
                    titlesList: (0,utils/* getMainTitlesNavigationFromBody */._H)((0,sharedUtils/* replacePlaceholders */.wT)(post.body, {
                        category
                    })),
                    allPosts: finalPosts
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/components/severalbrands/metaTags/index.tsx
var metaTags = __webpack_require__(66405);
;// CONCATENATED MODULE: ./pages/severalbrands/[...blog].tsx








var __N_SSG = true;
function SeveralBrandsHome({ post , allPosts , mainUrl , domain , metaTitle  }) {
    const category = post?.category?.label ?? post?.category?.name;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(severalBrandsWrapper/* default */.Z, {
        contentListExist: true,
        domainInfo: domain,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(metaTags/* default */.Z, {
                title: `${(0,sharedUtils/* replacePlaceholders */.wT)(metaTitle ? metaTitle : post.title, {
                    category
                })} | SeveralBrands.com`,
                description: (0,utils/* getDescriptionForPostByID */._7)(post),
                keyWords: (0,utils/* getKeyWordsForPostByID */.qp)(post, domain),
                image: post.image?.fullPath,
                url: mainUrl,
                type: "article"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstSection, {
                post: post,
                mainUrl: mainUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondSection, {
                post: post,
                allPosts: allPosts
            })
        ]
    });
}


/***/ }),

/***/ 73536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CloseIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "13",
        height: "13",
        fill: "none",
        viewBox: "0 0 13 13",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "#fff",
            d: "M.963 12.46L0 11.501 5.294 6.23 0 .958.963 0l5.293 5.272L11.55 0l.963.958L7.219 6.23l5.294 5.271-.963.959-5.294-5.272L.963 12.46z"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CloseIcon);


/***/ }),

/***/ 54531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gr": function() { return /* binding */ getUrl; },
/* harmony export */   "L0": function() { return /* binding */ getFormattedDate; },
/* harmony export */   "U8": function() { return /* binding */ getKeyWordsForMetaTags; },
/* harmony export */   "Z5": function() { return /* binding */ getMetaTitleDescriptionForPage; },
/* harmony export */   "_7": function() { return /* binding */ getDescriptionForPostByID; },
/* harmony export */   "_H": function() { return /* binding */ getMainTitlesNavigationFromBody; },
/* harmony export */   "fH": function() { return /* binding */ getFinalLogosForLogoSLider; },
/* harmony export */   "fx": function() { return /* binding */ getDescriptionForHomePage; },
/* harmony export */   "nn": function() { return /* binding */ addStyleClassToIframe; },
/* harmony export */   "qp": function() { return /* binding */ getKeyWordsForPostByID; },
/* harmony export */   "yV": function() { return /* binding */ addStyleClassToTable; }
/* harmony export */ });
/* unused harmony export extractExcerptFromBody */
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75094);

const getUrl = (pathname = "")=>{
    return `${window.location.origin}${pathname}`;
};
const getMainTitlesNavigationFromBody = (html)=>{
    const regex = /<[^>]+ id="([^"]+)"[^>]*>([\s\S]+?)<\/[^>]+>/g;
    const result = [];
    let match;
    while(match = regex.exec(html)){
        const [, id, content] = match;
        const textNodes = content.match(/>([^<]+)/g);
        if (textNodes) {
            result.push(// eslint-disable-next-line no-unsafe-optional-chaining
            ...textNodes?.map((node)=>({
                    value: node.substring(1).trim(),
                    id
                })));
        } else {
            result.push({
                value: content.trim(),
                id
            });
        }
    }
    return result.filter((i)=>i.value?.length > 1).map((el)=>({
            title: /^\d/.test(el.value) ? el.value.replace(/^\d/, "").slice(1) : el.value,
            link: `#${el.id}`
        }));
};
const addStyleClassToTable = (body)=>{
    if (body) {
        // start tag replace with <div className="table-responsive" > <table
        const firstSectionStartTag = body?.split("<table")[0]; // first section dose not contain <table to replace
        const bodyAfterReplaceStartTag = body?.split("<table").slice(1).map((table)=>{
            return `<div class="table-responsive"> <table ${table}`;
        });
        // final body after replace start tag
        const bodyAfterAddingStartTag = [
            firstSectionStartTag,
            ...bodyAfterReplaceStartTag, 
        ].join(" ");
        // end tag replace with </table> </div>
        const firstSectionEndTag = bodyAfterAddingStartTag.split("</table>")[0];
        const bodyAfterReplaceEndTag = bodyAfterAddingStartTag.split("</table>").slice(1).map((table)=>{
            return `</table></div>${table}`;
        });
        // final body after replace
        const finalBody = [
            firstSectionEndTag,
            ...bodyAfterReplaceEndTag
        ].join(" ");
        return finalBody;
    } else {
        return body;
    }
};
const addStyleClassToIframe = (body)=>{
    if (body) {
        // start tag replace with <div className="iframe-responsive" > <iframe
        const firstSectionStartTag = body?.split("<iframe")[0]; // first section dose not contain <iframe to replace
        const bodyAfterReplaceStartTag = body?.split("<iframe").slice(1).map((iframe)=>{
            return `<div class="iframe-responsive"> <iframe ${iframe}`;
        });
        // final body after replace start tag
        const bodyAfterAddingStartTag = [
            firstSectionStartTag,
            ...bodyAfterReplaceStartTag, 
        ].join(" ");
        // end tag replace with </iframe> </div>
        const firstSectionEndTag = bodyAfterAddingStartTag.split("</iframe>")[0];
        const bodyAfterReplaceEndTag = bodyAfterAddingStartTag.split("</iframe>").slice(1).map((iframe)=>{
            return `</iframe></div>${iframe}`;
        });
        // final body after replace
        const finalBody = [
            firstSectionEndTag,
            ...bodyAfterReplaceEndTag
        ].join(" ");
        return finalBody;
    } else {
        return body;
    }
};
const getFormattedDate = (date)=>{
    const regex = /^[0-9]+$/; //check if the string contain only numeric characters(time stamp)
    return new Date(regex.test(date) ? +date : date).toLocaleString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
};
const extractExcerptFromBody = (body, characters)=>{
    return body.replace(/<[^>]+>/g, "").substring(0, characters).trim();
};
const getDescriptionForPostByID = (post)=>{
    if (post && post?.metatags && post?.metatags?.length) {
        for(let i = 0; i < post?.metatags.length; i++){
            if (post.metatags[i]?.key === "description" && post.metatags[i]?.value) {
                return post?.metatags[i]?.value;
            }
        }
    }
    if (post?.excerpt) {
        return extractExcerptFromBody((0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__/* .replacePlaceholders */ .wT)(post.excerpt, {
            category: post?.category?.label ?? post?.category?.name
        }), 160);
    }
    if (post?.body) {
        return extractExcerptFromBody((0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_0__/* .replacePlaceholders */ .wT)(post.body, {
            category: post?.category?.label ?? post?.category?.name
        }), 160);
    }
    return "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks.";
};
const getKeyWordsForPostByID = (post, domainInfo)=>{
    if (post && post?.metatags && post?.metatags?.length) {
        for(let i = 0; i < post?.metatags.length; i++){
            if (post?.metatags[i]?.key === "keywords" && post?.metatags[i]?.value) {
                return post?.metatags[i]?.value;
            }
        }
    }
    if (post?.tags) {
        return post?.tags?.map((tag)=>tag?.name).join(",");
    }
    for(let i1 = 0; i1 < (domainInfo?.metatags.length ?? 0); i1++){
        if (domainInfo?.metatags[i1]?.key === "keywords" && domainInfo?.metatags[i1]?.value) {
            return domainInfo?.metatags[i1]?.value;
        }
    }
    return "";
};
const getDescriptionForHomePage = (domain)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        for(let i = 0; i < (domain?.metatags?.length ?? 0); i++){
            if (domain?.metatags[i]?.key === "extra-meta-HomePage-meta-description" && domain?.metatags[i]?.value) {
                return domain?.metatags[i]?.value;
            }
        }
    }
    if (domain?.description) {
        return domain.description.replace(/<[^>]+>/g, "");
    }
    return "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks.";
};
const getKeyWordsForMetaTags = (domain)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        for(let i = 0; i < (domain?.metatags?.length ?? 0); i++){
            if (domain?.metatags[i]?.key === "keywords" && domain?.metatags[i]?.value) {
                return domain?.metatags[i]?.value;
            }
        }
    }
    return "";
};
const getMetaTitleDescriptionForPage = (domain, keyPage)=>{
    if (domain && domain?.metatags && domain?.metatags?.length) {
        return {
            title: domain?.metatags.find((metaTag)=>metaTag.key === `extra-meta-${keyPage}-meta-title`)?.value,
            description: domain?.metatags.find((metaTag)=>metaTag.key === `extra-meta-${keyPage}-meta-description`)?.value
        };
    }
};
const getFinalLogosForLogoSLider = (featuredList, categorySlug)=>{
    const finalLogos = featuredList ? categorySlug ? featuredList[categorySlug] : featuredList["default"] : [];
    return finalLogos;
};


/***/ }),

/***/ 72875:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bgStyle":"style_bgStyle__AfrrH","toolTipText":"style_toolTipText__Zyko4"};

/***/ }),

/***/ 8859:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"postContainerSeveralBrandsDomain":"styles_postContainerSeveralBrandsDomain__wrL1r","media":"styles_media__zQ99F","media--type-remote-video":"styles_media--type-remote-video__DC3Az","media--type-video":"styles_media--type-video__nIhq0","align-center":"styles_align-center__tgx9m","media--type-video-embed":"styles_media--type-video-embed__9vZhK","embed-responsive":"styles_embed-responsive__lEj13","embed-responsive-item":"styles_embed-responsive-item__21QiL","litebox":"styles_litebox__B3O6r","blazy":"styles_blazy__X3bHv","embed-responsive-16by9":"styles_embed-responsive-16by9__xYiwt","clearfix":"styles_clearfix__aPiqg","box":"styles_box__lKBzQ","yellow-box":"styles_yellow-box__OSzr4","blue-box-bg":"styles_blue-box-bg__NGRKC","green-box-bg":"styles_green-box-bg___7_mX","red-box-bg":"styles_red-box-bg__UHf9P","yellow-box-bg":"styles_yellow-box-bg__jEuTV","image-hover":"styles_image-hover__LD6r_","blue-box":"styles_blue-box__eD89Y","btn":"styles_btn__z7v3m","table-responsive":"styles_table-responsive__ropvh","iframe-responsive":"styles_iframe-responsive__8t4lL"};

/***/ }),

/***/ 92665:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentsContainer":"style_contentsContainer__LYkkK","linksList":"style_linksList__p_m8T","bulletedListItem":"style_bulletedListItem__7eU_z","ellipsis-container":"style_ellipsis-container__ZNNvA","fixedStyle":"style_fixedStyle__fXBpz","contentsContainerList":"style_contentsContainerList__e_meD","mustReadLinks":"style_mustReadLinks__IXvMa","readMoreLink":"style_readMoreLink__l8Ell"};

/***/ }),

/***/ 54365:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__u7mvb","toolTipText":"styles_toolTipText__pVBr1"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [11943,91031,81711,49774,92888,40179], function() { return __webpack_exec__(78879); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);